import { Directive, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[flowMoreLink]',
  providers: [MatTooltip],
})
export class MoreLinkDirective {
  @Input() items: any[];

  constructor(private tooltip: MatTooltip) {}
  
  @HostListener('mouseover') mouseover() {
    this.tooltip.message = this.items.slice(1).map(c => c.name).join(', ');
    this.tooltip.show();
  }

  @HostListener('mouseleave') mouseleave() {
    this.tooltip.hide();
  }
}
